// Native app store links (single source of truth).
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.souqstream.app&pcampaignid=web_share";
export const APP_STORE_URL = "https://apps.apple.com/us/app/souqstream/id6802727581";

export const openExternal = (url) => {
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};
